import { NavigationService } from "@/shared/services/NavigationService";
import { SystemView } from "@/shared/constants/Views.enum";
import { PartialPatient } from "@/modules/DoctorProfile/models/AppointmentItem";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import {
  AVAILABILITY_CONSTANTS,
  EVENTS_STATES
} from "../../constants/AvailabilityConstants";
import {
  EventGeneralInfo,
  EventPatients
} from "../../models/EventPatients.model";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";

Vue.use(Vuetify);

@Component({
  name: "DetailConsulting",
  components: {
    ModalTemplate
  }
})
export default class DetailConsulting extends Vue {
  @Prop() private data!: EventPatients;
  @Prop() private color!: string;

  OPTIONS_LABEL = AVAILABILITY_CONSTANTS.LABEL.OPTIONS;
  ITEMS_SELECT_LIST = AVAILABILITY_CONSTANTS.TEXTS.ITEMS_SELECT_LIST;
  DETAIL_TAKEN_OPTION =
    AVAILABILITY_CONSTANTS.SELECT_TAKEN_OPTION.DETAILS.TITLE;
  EVENTS_TAKEN_OPTION = AVAILABILITY_CONSTANTS.SELECT_TAKEN_OPTION.EVENTS.TITLE;
  DETAIL_LABEL_TAGS = AVAILABILITY_CONSTANTS.DETAIL_LABELS;
  EVENT_LABELS_TAGS = AVAILABILITY_CONSTANTS.EVENT_LABELS;
  USER_DEFAULT_ROUTE = AVAILABILITY_CONSTANTS.USER_DEFAULT_ROUTE;

  rowDetailClass = STYLE_CLASSES.ROW_GENERAL_DETAIL;
  rowSubDetailClass = STYLE_CLASSES.ROW_SUB_GENERAL_DETAIL;
  textAlignment = STYLE_CLASSES.LOCAL_TEXT_STYLE;
  fontWeight = STYLE_CLASSES.FONT_WEIGHT;
  marginEventInfo = STYLE_CLASSES.MARGIN_EVENT_INFO;
  userIcon = STYLE_CLASSES.USER_ICON_LINK;
  divStyleEvents = STYLE_CLASSES.DIV_STYLE_EVENTS;

  info: EventGeneralInfo = {} as EventGeneralInfo;
  cardPatientsInfo: Array<PartialPatient> = [];
  optionValue = "";
  COLOR = "";
  INFO = AVAILABILITY_CONSTANTS.TEXTS.INFO;
  statusLabelClass = "";
  MINUTES = AVAILABILITY_CONSTANTS.TEXTS.MINUTES;
  valuesFlag = false;
  modalConfirmationText = "";
  modalConfirmationTitle = "";
  showModalConfirmation = false;
  patientId = "";

  mounted() {
    this.handleEventsChange();
  }

  @Watch("data")
  handleEventsChange() {
    if (Object.keys(this.data).length > 0) {
      this.info = this.data.info;
      this.cardPatientsInfo = this.data.patients;
      this.COLOR = this.color;
      this.setLabelStatusColor();
      this.valuesFlag = true;
    }
  }

  userCalendarCollection() {
    NavigationService.navigateTo(SystemView.USER);
  }

  redirectToPatientProfile() {
    NavigationService.navigateTo(SystemView.PROFILE, { id: this.patientId });
  }

  setLabelStatusColor() {
    this.statusLabelClass = AVAILABILITY_CONSTANTS.STYLES.STATUS_CHIP_BLOCKED;
    if (this.info.status === EVENTS_STATES.RESERVED) {
      this.statusLabelClass =
        AVAILABILITY_CONSTANTS.STYLES.STATUS_CHIP_RESERVED;
      return;
    }
    if (this.info.status === EVENTS_STATES.AVAILABLE) {
      this.statusLabelClass =
        AVAILABILITY_CONSTANTS.STYLES.STATUS_CHIP_AVAILABLE;
      return;
    }
  }

  confirmRedirectToPatient(patientId: string) {
    this.patientId = patientId;
    this.modalConfirmationText =
      AVAILABILITY_CONSTANTS.TEXTS.REDIRECT_TO_PATIENT_PROFILE;
    this.showModalConfirmation = true;
  }

  handleModalCancel() {
    this.showModalConfirmation = false;
  }

  handleModalAccept() {
    this.showModalConfirmation = false;
    this.redirectToPatientProfile();
  }
}
